export const GET_GALLERY_FOLDERS = 'GET_GALLERY_FOLDERS';
export const DELETE_GALLERY_FILE = 'DELETE_GALLERY_FILE';
export const UPDATE_GALLERY_FILE = 'UPDATE_GALLERY_FILE';
